<ng-container>
  <span [attr.aria-label]="pointsAriaLabel"> {{ pointsDisplay }}</span>
</ng-container>
